/** ID счётчика (совпадает с public/index.html) */
export const YANDEX_METRIKA_ID = 110349970;

/**
 * Просмотр виртуальной страницы для SPA (после init с defer: true).
 * @see https://yandex.ru/support/metrica/code/counter-spa-setup.html
 */
export function yandexMetrikaHit(url, options = {}) {
  if (typeof window === "undefined" || typeof window.ym !== "function") {
    return;
  }
  const pageUrl = url ?? window.location.href;
  window.ym(YANDEX_METRIKA_ID, "hit", pageUrl, {
    title: document.title,
    ...options,
  });
}

export function yandexMetrikaReachGoal(targetName, params) {
  if (typeof window === "undefined" || typeof window.ym !== "function") {
    return;
  }
  if (params !== undefined) {
    window.ym(YANDEX_METRIKA_ID, "reachGoal", targetName, params);
  } else {
    window.ym(YANDEX_METRIKA_ID, "reachGoal", targetName);
  }
}

export function yandexMetrikaParams(params) {
  if (typeof window === "undefined" || typeof window.ym !== "function") {
    return;
  }
  window.ym(YANDEX_METRIKA_ID, "params", params);
}

export {
  METRIKA_GOALS,
  trackTryClick,
  trackRegistrationSuccess,
  trackActivationComplete,
  trackPaymentSuccess,
} from "./metrikaGoals";
